<template>
  <div id="twitch-embed"></div>
</template>

<script>
export default {
  created() {
    this.$nextTick(() => {
      let embed = new Twitch.Embed("twitch-embed", {
        channel: "slothtech",
        width: "100%",
        height: "100%",
        theme: "dark",
        parent: ["events.slothtech.io"]
      });

      embed.addEventListener(Twitch.Embed.VIDEO_READY, () => {
        var player = embed.getPlayer();
        player.play();
      });
    });
  }
};
</script>

<style lang="scss">
#twitch-embed {
  width: 100vw;
  height: 100vh;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>